import type { ContainerSizeInput } from '@chukua/common';
import { api } from '../../../../shared/shared.api';
import { listContainerSizes, type ContainerSize } from '../../reference-data.api';
import type { CatalogueApi } from '../../hooks/use-catalogue';

/** Admin-managed (`configuration.manage`, gitaumoses4/chukua#355); the list call and row type are shared with the pickers, so they stay in `reference-data.api.ts`. */
export const containerSizesApi: CatalogueApi<ContainerSize, ContainerSizeInput> = {
  list: listContainerSizes,
  create: (input) => api<ContainerSize>('/container-sizes', { method: 'POST', body: JSON.stringify(input) }),
  update: (id, input) => api<ContainerSize>(`/container-sizes/${id}`, { method: 'PATCH', body: JSON.stringify(input) }),
  deactivate: async (id) => {
    await api<void>(`/container-sizes/${id}/deactivate`, { method: 'POST' });
  },
  reactivate: async (id) => {
    await api<void>(`/container-sizes/${id}/reactivate`, { method: 'POST' });
  },
};
